import React, { useEffect, useState } from 'react';
import { Header } from '../../components/Header';
import { useSelector, useDispatch } from 'react-redux';
import '../../style/articlePage.scss';
import '../../style/main.scss';
import { ArticleHeader } from '../../components/ArticleHeader';
import { getAllArticles, getOneArticle } from '../../store/actions/actions';
import { useHistory, Redirect } from 'react-router-dom';
import { Spin } from 'antd';
import { useTranslation, withTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
import jwt from 'jsonwebtoken';
import 'moment/locale/sq';
moment.locale('sq');

const Article = ({ ...props }) => {
  const articleId = props.match.params.id;
  const [pathId, setPathId] = useState('');
  const articleResponse = useSelector(({ articles }) => articles.getAll);
  const articleGetOneResponse = useSelector(({ articles }) => articles.getOne);
  const language = useSelector((state) => state.language);

  const token = localStorage.getItem('kgen-token');

  let role;
  if (token) {
    const decodedToken = jwt.decode(token);
    role = decodedToken.role;
  }

  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    let articlePathId = window.location.pathname.split('/')[1];
    dispatch(getOneArticle({ articleId }));
    setPathId(articlePathId);
  }, [articleId]);

  useEffect(() => {
    dispatch(getAllArticles({ pagination: false }));
  }, []);

  const goToArticle = async (id) => {
    await history.push(`/${id}`);
  };

  const articleHeader = () => {
    if (articleGetOneResponse && articleGetOneResponse.loading) {
      return <Spin style={{ margin: '310px auto' }} indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />} />;
    } else if (articleGetOneResponse && articleGetOneResponse.success) {
      const { _id, type, createdAt, localisations, photo } = articleGetOneResponse.data.article;
      return (
        <div className="col-sm-8">
          <div className="row">
            <ArticleHeader
              id={pathId}
              tag={type.toUpperCase()}
              title={localisations[language].title}
              time={moment(createdAt).format('DD MMMM YYYY HH:mm')}
            />
          </div>
          <div className="row">
            <div className="col pt-1 pb-3">
              <img src={photo} alt="article-image" width="100%" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div
                className="content-body-html"
                style={{ color: '#1e1e1e !important', fontFamily: 'Mark-Light' }}
                dangerouslySetInnerHTML={{
                  __html: localisations[language].text,
                }}
              ></div>
            </div>
          </div>
        </div>
      );
    }
  };

  if (token && role !== 'intern') return <Redirect to="/" />;
  return (
    <div style={{ backgroundColor: 'white' }}>
      <Header {...props} />
      <div id="article" className="page-wrapper">
        <div className="container">
          <div className="row">
            {articleHeader()}
            <div className="col-sm-4">
              <div className="container">
                <h4 className="title-article">{t('all')}</h4>
                <div className="row" style={{ marginBottom: '20px' }}>
                  {articleResponse &&
                    articleResponse.success &&
                    articleResponse?.data.articles.docs.map((article) => (
                      <div key={article._id} className="col-sm-12 articleDirect">
                        <div className="item-wrapper" onClick={() => goToArticle(article._id)}>
                          <div className="row">
                            <div className="col-sm-5 left-side">
                              <img src={article?.photo} />
                            </div>
                            <div className="col-sm-7 right-side">
                              <div className="top-wrapper">
                                <p>
                                  <a style={{ fontFamily: 'Mark-Light' }}>
                                    {article?.type == 'news' ? t('news') : t('event')}
                                  </a>
                                </p>
                                <p style={{ color: '#1e1e1e', fontFamily: 'Mark-Light' }}>
                                  {moment(article?.createdAt).format('MMMM DD, YYYY')}
                                </p>
                              </div>
                              <div className="content-article">
                                <p>{article?.localisations[language].title}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withTranslation('translations')(Article);
